
import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  markdown: {
    ...theme.typography.body2,
    padding: theme.spacing(3, 0),
  },
  root: {
    height: 'calc(100vh - 64px)',
    overflow: 'hidden',
    // '& > *': {
    //   padding: theme.spacing(1),
    // },
  },
  subtitle: {
    marginTop: 5,
    marginBottom: 5,
    fontSize: 15
  },
  formContanier: {
    // background: themes.default.palette.primary.light,
    // background: `${themes[user.theme].palette.primary.main}77`,
    background: '#ddd',
    height: 'calc(100vh - 64px)',
    overflowY: 'auto',
    width: 360
  },
  form: {
    '& > *': {
      padding: theme.spacing(1),
    },
  },
  button: {
    textAlign: 'center'
  },
  grund: {
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh'
  },
  alert: {
    margin: theme.spacing(1),
  }
}));